<template>
  <div id="scholarRz">
    <Form
      ref="formValidate"
      :model="subData"
      :rules="ruleValidate"
      :label-width="140"
      label-position="left"
    >
      <div class="title">基本信息</div>
      <FormItem label="姓名" prop="userInfo.realname">
        <Input
          placeholder
          v-model="subData.userInfo.realname"
          style="width: 300px"
        />
      </FormItem>
      <FormItem label="头像" prop="userInfo.headPhoto">
        <Upload
          class="upload"
          :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
          :headers="{ token: token }"
          accept=".png,.jpg,.jpeg"
          :format="['jpg', 'jpeg', 'png']"
          key="coverImg"
          :show-upload-list="false"
          :max-size="1024"
          :on-exceeded-size="handleMaxSize"
          :on-success="headPhotoSuccess"
        >
          <img
            class="img"
            v-if="subData.userInfo.headPhoto.length !== 0"
            v-lazy="$global.imgUrl + subData.userInfo.headPhoto"
            alt
          />
          <img v-else class="img" src="@/assets/img/userInfo/add.png" alt />
        </Upload>
        <div class="tishi">支持JPG、JPEG、PNG格式，图片不超过 1M</div>
      </FormItem>
      <FormItem label="最高学历" prop="userInfo.education">
        <Select v-model="subData.userInfo.education" style="width: 300px">
          <Option value="博士研究生">博士研究生</Option>
          <Option value="硕士研究生">硕士研究生</Option>
          <Option value="本科">本科</Option>
          <Option value="专科">专科</Option>
          <Option value="其他">其他</Option>
        </Select>
      </FormItem>
      <FormItem label="毕业院校" prop="userInfo.school">
        <Input
          placeholder
          v-model="subData.userInfo.school"
          style="width: 300px"
        />
      </FormItem>
      <FormItem label="现单位/院校" prop="userInfo.unit">
        <Input
          placeholder
          v-model="subData.userInfo.unit"
          style="width: 300px"
        />
      </FormItem>
      <FormItem label="现任职位">
        <Input
          placeholder
          v-model="subData.userInfo.job"
          style="width: 300px"
        />
      </FormItem>
      <FormItem label="职称" :required="true">
        <div
          class="list-item"
          v-for="(item, index) in subData.titles"
          :key="index"
        >
          <FormItem
            style="display: inline-block"
            :prop="'titles.' + index + '.levelOne'"
            :rules="[
              {
                type: 'number',
                required: true,
                message: '职称级别不能为空',
                trigger: 'change',
              },
            ]"
          >
            <Select
              style="width: 150px; margin-right: 10px"
              placeholder="请选择职称级别"
              v-model="item.levelOne"
            >
              <Option
                v-for="obj in titleOptions"
                :key="obj.titleCode"
                :value="obj.titleCode"
                >{{ obj.titleName }}</Option
              >
            </Select>
          </FormItem>
          <FormItem
            style="display: inline-block"
            :prop="'titles.' + index + '.levelTwo'"
            :rules="[
              {
                required: true,
                message: '职称不能为空',
                trigger: 'blur',
              },
            ]"
          >
            <Input
              style="width: 250px; margin-right: 10px"
              placeholder="请输入职称"
              v-model="item.levelTwo"
            />
          </FormItem>
          <Icon
            style="cursor: pointer; vertical-align: middle"
            :type="
              index < subData.titles.length - 1 || index === 4
                ? 'md-remove-circle'
                : 'md-add-circle'
            "
            size="26"
            color="#999999"
            @click="addTitles(item, index)"
          />
        </div>
      </FormItem>
      <FormItem label="学科领域" :required="true">
        <FormItem
          class="list-item"
          v-for="(item, index) in subData.subjects"
          :key="item.id"
          :prop="'subjects.' + index + '.levelOne'"
          :rules="[
            {
              required: true,
              message: '学科领域不能为空',
              trigger: 'change',
            },
          ]"
        >
          <Cascader
            style="display: inline-block; width: 300px; margin-right: 10px"
            placeholder="请输入学科领域"
            filterable
            trigger="hover"
            :value="[item.levelOne, item.levelTwo]"
            :data="subjectsOptions"
            @on-change="
              (value) => {
                subjectsChange(value, index);
              }
            "
          ></Cascader>
          <Icon
            style="cursor: pointer; vertical-align: middle"
            :type="
              index < subData.subjects.length - 1 || index === 4
                ? 'md-remove-circle'
                : 'md-add-circle'
            "
            size="26"
            color="#999999"
            @click="addSubjects(item, index)"
          />
        </FormItem>
      </FormItem>
      <FormItem label="研究方向" prop="userInfo.researchDirection">
        <Input
          placeholder="请输入研究方向"
          v-model="subData.userInfo.researchDirection"
          style="width: 300px"
        />
      </FormItem>
      <div class="title">实名信息</div>
      <FormItem label="身份证号" prop="userInfo.idCard">
        <Input
          placeholder
          v-model="subData.userInfo.idCard"
          style="width: 300px"
        />
      </FormItem>
      <FormItem label="身份证图片" :required="true">
        <div style="display: flex; width: 100%">
          <FormItem prop="userInfo.idCardFront">
            <Upload
              class="upload"
              :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
              :headers="{ token: token }"
              :format="['jpg', 'jpeg', 'png']"
              accept=".png,.jpg,.jpeg"
              :max-size="1024"
              :show-upload-list="false"
              :on-exceeded-size="handleMaxSize"
              :on-success="idCardFrontFrontSuccess"
            >
              <img
                class="IDimg"
                v-if="subData.userInfo.idCardFront.length !== 0"
                v-lazy="$global.imgUrl + subData.userInfo.idCardFront"
                alt
              />
              <img
                v-else
                class="IDimg"
                src="@/assets/img/userInfo/zid.png"
                alt
              />
            </Upload>
          </FormItem>
          <FormItem prop="userInfo.idCardBack" style="margin-left: 20px">
            <Upload
              class="upload"
              :action="`${$global.uplodeUrl}zw-public/web/common/upload`"
              :headers="{ token: token }"
              accept=".png,.jpg,.jpeg"
              :format="['jpg', 'jpeg', 'png']"
              :max-size="1024"
              :show-upload-list="false"
              :on-exceeded-size="handleMaxSize"
              :on-success="idCardBackBackSuccess"
            >
              <img
                class="IDimg"
                v-if="subData.userInfo.idCardBack.length !== 0"
                v-lazy="$global.imgUrl + subData.userInfo.idCardBack"
                alt
              />
              <img
                v-else
                class="IDimg"
                src="@/assets/img/userInfo/fid.png"
                alt
              />
            </Upload>
          </FormItem>
        </div>
        <div style="margin-top: 20px">
          支持JPG、JPEG、PNG格式，图片不超过 1M
        </div>
      </FormItem>
    </Form>
    <Button
      class="button"
      v-throttleClick
      size="large"
      :type="reviewStatus == '0' ? 'default' : 'primary'"
      @click="sub"
      >{{ reviewStatus == "0" ? "审核中" : "提交" }}</Button
    >
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "index",
  computed: {
    ...mapState(["token", "userInfo"]),
  },
  data() {
    const validateidCard = (rule, value, callback) => {
      let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (value === "") {
        callback(new Error("身份证号不能为空"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的身份证号"));
      } else {
        callback();
      }
    };
    return {
      reviewStatus: 0,
      titleOptions: [],
      subjectsOptions: [],
      subData: {
        titles: [
          {
            levelOne: "",
            levelTwo: "",
          },
        ],
        subjects: [
          {
            id: Math.random()*50,
            levelOne: "",
            levelOneName: "",
            levelTwo: "",
            levelTwoName: "",
          },
        ],
        userInfo: {
          realname: "",
          headPhoto: "",
          education: "",
          school: "",
          unit: "",
          job: "",
          researchDirection: "",
          idCard: "",
          idCardFront: "",
          idCardBack: "",
        },
      },
      ruleValidate: {
        "userInfo.realname": [
          { required: true, message: "姓名不能为空", trigger: "blur" },
        ],
        "userInfo.headPhoto": [
          { required: true, message: "头像不能为空", trigger: "change" },
        ],
        "userInfo.education": [
          { required: true, message: "最高学历不能为空", trigger: "change" },
        ],
        "userInfo.school": [
          { required: true, message: "毕业院校不能为空", trigger: "blur" },
        ],
        "userInfo.unit": [
          { required: true, message: "现单位/院校不能为空", trigger: "blur" },
        ],
        "userInfo.researchDirection": [
          { required: true, message: "研究方向不能为空", trigger: "blur" },
        ],
        "userInfo.idCard": [
          { required: true, validator: validateidCard, trigger: "blur" },
        ],
        "userInfo.idCardFront": [
          { required: true, message: "身份证反面不能为空", trigger: "change" },
        ],
        "userInfo.idCardBack": [
          { required: true, message: "身份证正面不能为空", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.type();
    this.getleveData();
    this.getSubjectsOptions();
  },
  methods: {
    async type() {
      let res = await this.$apis.userServe.userEditTypes();
      this.reviewStatus = res.content.status;
    },
    // 提交
    async sub() {
      if (this.userInfo.user.customerType === 1) {
        if (this.reviewStatus === -1 || this.reviewStatus === 3) {
          this.$refs.formValidate.validate(async (valid) => {
            if (valid) {
              let res = await this.$apis.userServe.subscholar(this.subData);
              if (res.data.resultCode === "200") {
                this.$Message.success("提交成功");
                this.$router.push("/user/authentication");
              } else {
                this.$Message.error(res.data.resultDesc);
                return;
              }
            } else {
              this.$Message.error("表单填写错误,请检查后重新提交");
              return;
            }
          });
        } else {
          this.$Message.warning("正在审核中");
          return;
        }
        // await this.$router.push("/user/review");
      } else {
        this.$Message.error("当前用户不能提交认证");
      }
    },
    // 上传图片超过大小
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "图片上传过大",
        desc: file.name + "该文件大小超过1M.",
      });
    },
    // 身份证图片
    idCardFrontFrontSuccess(res, file) {
      this.subData.userInfo.idCardFront = res.content.url;
    },
    // 身份证图片
    idCardBackBackSuccess(res, file) {
      this.subData.userInfo.idCardBack = res.content.url;
    },
    // 头像图片
    headPhotoSuccess(res) {
      this.subData.userInfo.headPhoto = res.content.url;
    },
    // 学科领域选择
    subjectsChange(value, index) {
      let One = "";
      let Two = "";
      this.subjectsOptions.forEach((item) => {
        if (item.value === value[0]) {
          One = item.label;
          item.children.forEach((i) => {
            if (i.value === value[1]) {
              Two = i.label;
            }
          });
        }
      });
      this.subData.subjects[index].levelOne = value[0];
      this.subData.subjects[index].levelOneName = One;
      this.subData.subjects[index].levelTwo = value[1];
      this.subData.subjects[index].levelTwoName = Two;
    },
    // 添加学科领域
    addSubjects(item, index) {
      if (index < this.subData.subjects.length - 1 || index === 4) {
        this.subData.subjects.splice(index, 1);
      } else {
        if (item.levelOne && item.levelTwo) {
          this.subData.subjects.push({
            id: Math.random()*50,
            levelOne: "",
            levelOneName: "",
            levelTwo: "",
            levelTwoName: "",
          });
        }
      }
    },
    // 获取学科领域下拉数据
    async getSubjectsOptions() {
      const { data } = await this.$apis.userServe.getRelationList();
      this.subjectsOptions = [...data];
    },
    // 添加职称
    addTitles(item, index) {
      if (index < this.subData.titles.length - 1 || index === 4) {
        this.subData.titles.splice(index, 1);
      } else {
        if (item.levelOne && item.levelTwo) {
          this.subData.titles.push({
            levelOne: "",
            levelTwo: "",
          });
        }
      }
    },
    // 获取职称级别下拉数据
    async getleveData() {
      const { data } = await this.$apis.userServe.getTitleList();
      this.titleOptions = [...data];
    },
  },
};
</script>

<style lang="scss" scoped>
#scholarRz {
  width: 1200px;
  padding-top: 50px;
  min-height: 1200px;
  background: #ffffff;
  padding-left: 40px;
  padding-bottom: 20px;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  &::v-deep .ivu-form-item-label {
    color: #333333;
  }
  .title {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 40px;
  }

  .img {
    width: 70px;
    height: 98px;
    margin-right: 20px;
  }
  .IDimg {
    width: 296px;
    height: 163px;
    //background: pink;
    border-radius: 6px;
  }

  .list-item {
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
    &::v-deep .ivu-select-dropdown {
      top: 35px !important;
    }
  }

  .button {
    display: block;
    margin: 50px auto 0;
  }

  // .list {
  //   display: flex;
  //   align-items: center;
  //   margin-top: 10px;
  //   flex-wrap: wrap;
  //   width: 100%;
  // }
}
</style>
